import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth';

import PaymentLinkV2Page from './PaymentLinkV2Page';

const PaymentLinkRoute: FuseRouteItemType[] = [];

PaymentLinkRoute.push({
  path: 'payment-link/v2/:id',
  element: <PaymentLinkV2Page />,
  auth: AUTH_ROLES.onlyGuest || AUTH_ROLES.user,
});

export default PaymentLinkRoute;
